/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/js/js/aa/shopping/searchFlights.js
 *    TO   --> ./shopping-web/src/main/assets/js/search-flights.js
 **/

AAcom(
    'browserdetect',
    'commonsetup',
    'utilities',
    'ajax',
    'aaDatePicker',
    'aaMobileDatePicker',
    'aaAutoComplete',
    'airportLookup',
    'nearestAirportLookup',
    function(AAUI) {
        'use strict';

        $j(function() {
            /**
             * Recent search module
             * @type {object}
             * @param {object} jQuery plugin object
             */
            var recentSearches = $j.fn.aaRecentSearch();

            /**
             * Advanced search page script for mobile and normal view
             * @type {object}
             * @param {jQuery} jQuery plugin object
             * @param {device} device with mobile/normal/tablet properties
             */
            var search = (function($j, device, cache) {
                /**
                 * Trip type nav tab
                 */
                var tripType = {
                    RoundTrip: 'roundTrip',
                    OneWay: 'oneWay',
                    MultiCity: 'multi'
                };

                var MAX_PAX = 9,
                    MAX_FLIGHT_SEGMENT = AAUI.getProperty('MAX_SEGMENT_ALLOWED') || 4,
                    AWARD_MAX_FLIGHT_SEGMENT = AAUI.getProperty('MAX_AWARD_SEGMENT_ALLOWED') || 4,
                    FLIGHT_SEARCH_FORM_CACHE_KEY = 'flightSearchView',
                    TRIP_TYPE_CACHE_KEY = 'TRIP_TYPE_KEY',
                    AWARD_CACHE_KEY = 'AWARD_KEY',
                    selectedTripType = tripType.RoundTrip,
                    tripTypeNavTabMappings /* active tab index -> trip type mappings */,
                    isSecure = AAUI.getProperty('account.isSecure') === 'true',
                    firstDestination = 'segments[0].destination',
                    homeTownAirport = AAUI.getProperty('HomeTownAirport'),
                    clearRecentSearchesKey = AAUI.getProperty('ClearRecentSearchesKey'),
                    originIsHomeTown = false,
                    $flightSearchForm = $j('#flightSearchView'),
                    loadingTxt = AAUI.getProperty('LoadingText'),
                    dateFormat = AAUI.getProperty('DateFormat')
                        .replace(/MM/g, 'mm')
                        .replace(/yy/g, 'y'),
                    templates = {},
                    redeemMilesCheckbox = '#awardBooking',
                    tripLinkCheckbox = '#tripLink',
                    airPassCheckbox = '#airpass\\.useAirpass',
                    isFromHomePage = false,
                    isRedeemMiles = false,
                    isTripLinkBooking = false,
                    isAirPassBooking = false,
                    tripLinkBooking = '#tripLinkBooking',
                    airPassBooking = '#airPassBooking',
                    isAirpassNextGen = AAUI.getProperty('airpassNextGen'),
                    isAirpassCompanionAllowed = AAUI.getProperty('airpassCompanionAllowed'),
                    tripLinkAccount = AAUI.getProperty('tripLinkAccount'),
                    tripLinkOnlyAccount = AAUI.getProperty('tripLinkOnlyAccount'),
                    corporateAccount = AAUI.getProperty('corporateAccount'),
                    businessCompanyNames = AAUI.getProperty('businessCompanyNames'),
                    businessCompanyNamesCount = AAUI.getProperty('businessCompanyNamesCount'),
                    corporateName = AAUI.getProperty('corporateName'),
                    businessTraveler = AAUI.getProperty('businessTraveler'),
                    userLocale = AAUI.getProperty('user.locale') || 'en_US',
                    milesBalanceTxt = AAUI.getProperty('milesBalanceTxt'),
                    revenueSpa = false;

                /**
                 * Get correct jQuery id format
                 * @param {string} elem id
                 * @return {string} element id in correct format
                 */
                var getId = function(elemId) {
                    if (!elemId) {
                        return '';
                    }

                    return '#' + elemId.replace(/[:.\[\],\\]/g, '\\$&');
                };

                /**
                 * Returns Trip type value name
                 * @param {int} index of selected tab from nav
                 * @return {string} Trip type value of index
                 */
                var getTripType = function(selectedTabIndex) {
                    return tripTypeNavTabMappings[selectedTabIndex];
                };

                /**
                 * Save selected Trip type from nav tab and update form
                 * @param {int} index of selected tab
                 */
                var setTripType = function(selectedTabIndex) {
                    selectedTripType = getTripType(selectedTabIndex);
                    cache.get('#tripType').val(selectedTripType);
                    updateFormViewCSS(selectedTripType);
                };

                /**
                 * Add css for mobile view
                 * @param {string} selectedTripType
                 */
                var updateFormViewCSS = function(selectedTripType) {
                    if ('oneWay' === selectedTripType || selectedTripType === 'roundTrip') {
                        $flightSearchForm.addClass('compact-view');
                    } else {
                        $flightSearchForm.removeClass('compact-view');
                    }
                };

                /**
                 * Get selected trip type
                 * @return {string} Trip type value
                 */
                var getCurrentTripType = function() {
                    return selectedTripType;
                };

                var debounce = function(func, timeout = 300) {
                    let timer;
                    return (...args) => {
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            func.apply(this, args);
                        }, timeout);
                    };
                };

                /**
                 * Initialize Date Picker
                 */
                var initDatePicker = function(isMobile, selector) {
                    if (isMobile) {
                        var hasMobileDatePicker = false;
                        $j('.aaRangeDatePicker').each(function(index) {
                            hasMobileDatePicker = $j(this).hasClass('hasMobileDatePicker');
                        });

                        // do not rebind mobile date-picker
                        if (hasMobileDatePicker) {
                            return;
                        }

                        if (!selector && tripType.MultiCity === getCurrentTripType()) {
                            var segmentCount = cache.get('.airport-segment').length || 2;
                            for (var i = 1; i < segmentCount; i++) {
                                const mobileDatePickerInput = {
                                    dateRange: {
                                        start: '#segments' + (i - 1) + '\\.travelDate',
                                        end: '#segments' + i + '\\.travelDate'
                                    }
                                };

                                AAUI.initMobileDatePicker(mobileDatePickerInput);
                            }
                        } else {
                            let mobileDatePicker = selector || {
                                dateRange: { start: '#segments0\\.travelDate', end: '#segments1\\.travelDate' }
                            };

                            AAUI.initMobileDatePicker(mobileDatePicker);
                        }
                        return;
                    }

                    let desktopDatePicker = selector || '.aaRangeDatePicker';
                    // remove mobile datepicker from departure date
                    $j('.ui-datepicker-trigger.mobile-datepicker')
                        .off('click')
                        .remove();
                    $j(desktopDatePicker)
                        .datepicker('destroy')
                        .off('focus')
                        .removeClass('hasMobileDatePicker');
                    AAUI.dateRangePicker(desktopDatePicker, { beforeShow: onBeforeShow });
                };

                /**
                 * Get int value of Trip type
                 * @param {string} selectedTripType Trip type value
                 * @return {number} int equal to trip type
                 */
                var tripTypeValueToInt = function(selectedTripType) {
                    switch (selectedTripType) {
                        case tripType.OneWay:
                            return 1;
                        case tripType.MultiCity:
                            return 2;
                    }

                    return 0; // Round-trip
                };

                /**
                 * Replace the options of a select element
                 * @param {object} jquery select object
                 * @param {options} array of name-value pairs
                 */
                var replaceOptions = function($select, options) {
                    if (!options || !options.length) {
                        return;
                    }

                    var i = 0,
                        listSize = options.length;

                    $select.empty();
                    for (; i < listSize; i++) {
                        $select.append(
                            $j('<option>')
                                .prop('value', options[i].value)
                                .prop('text', options[i].name)
                        );
                    }
                };

                /**
                 * Toggle refundable and airpass checkbox
                 * user can only select one
                 * @param {boolean} selected checkbox
                 * @param {string} id of checkbox
                 */
                var toggleCheckbox = function(isChecked, target, container) {
                    if (isChecked) {
                        cache.get(target).prop('checked', false);
                        cache.get(container).hide();
                    } else {
                        cache.get(container).show();
                    }
                };

                /**
                 * Toggles between award and revenue search by options for one-way and round-trip
                 */
                var toggleOneWayOrRoundTripSearchByList = function() {
                    if (isRedeemMiles) {
                        cache.get('#revenueSearchOptionLabel').hide();
                        cache.get('#awardSearchOptionLabel').hide();
                    } else {
                        cache.get('#awardSearchOptionLabel').hide();
                        cache.get('#revenueSearchOptionLabel').hide();
                    }
                };

                /**
                 * Toggles between award and revenue search by options for multi-city
                 */
                var toggleMultiCitySearchByList = function() {
                    if (isRedeemMiles) {
                        cache.get('#revenueSearchOptionLabel').hide();
                        cache.get('#awardSearchOptionLabel').hide();
                    } else {
                        cache.get('#awardSearchOptionLabel').hide();
                        cache.get('#revenueSearchOptionLabel').hide();
                    }
                };

                /**
                 * Retrieve the origin-destination airports for One-way Or Round-Trip
                 */
                var getAirports = function() {
                    return [$j('#segments0\\.origin').val(), $j('#segments0\\.destination').val()];
                };

                /**
                 * Show max 6 or 9 passengers
                 * @param {boolean} showMaxPassenger
                 */
                var updatePassengerList = function() {
                    if (isAirPassBooking) {
                        toggleAirpassPassengerList(isAirpassCompanionAllowed, true);
                        return;
                    }

                    var paxCount = cache.get('#passengerCount').val();
                    showPassengers(paxCount);
                };

                /**
                 * Enable/disable passenger 2/3-6 from passenger select option
                 * @param {boolean} disable7To9PassengerSelection
                 */
                var toggleAirpassPassengerList = function(companionAllowed, disablePassengerSelection) {
                    var currentPaxCount = cache.get('#passengerCount').val();
                    var paxCountToSet = companionAllowed && currentPaxCount == 2 ? 2 : 1;

                    cache.get('#passengerCount').val(paxCountToSet);

                    var startingPassengerIndex = companionAllowed ? 3 : 2;
                    for (var i = startingPassengerIndex; i <= 9; i++) {
                        cache
                            .get('#passengerCount option[value="' + i + '"]')
                            .prop('disabled', disablePassengerSelection)
                            .prop('hidden', disablePassengerSelection);
                    }
                    showPassengers(paxCountToSet);
                };

                /**
                 * Enable maximum nine passengers for one-way and round-trip
                 */
                var toggleOneWayOrRoundTripPassengerOptions = function() {
                    updatePassengerList();
                };

                /**
                 * Only allow six maximum passenger for multi-city
                 */
                var toggleMultiCityPassengerOptions = function() {
                    updatePassengerList();
                };

                /**
                 * Display the selected number of passengers
                 * @param {number} passengerCount selected number of passengers
                 */
                var showPassengers = function(passengerCount) {
                    var i = MAX_PAX;

                    while (i--) {
                        cache.get('#passenger' + i).toggle(i < passengerCount);
                    }
                };

                /**
                 * Reset passengers drop down to default Adult type
                 */
                var resetPassengersTypes = function() {
                    var i = MAX_PAX;

                    while (i--) {
                        cache.get('#passengers' + i + '\\.passengerType').val('ADULT');
                    }
                };

                /**
                 * One way and Round trip options
                 */
                var setTripOptions = function() {
                    cache.get('#partnerAirlineLink').toggle(isRedeemMiles);
                    cache.get('#optionsSection').toggle(!isAirPassBooking);

                    toggleOneWayOrRoundTripSearchByList();
                    toggleOneWayOrRoundTripPassengerOptions();
                };

                /**
                 * Multi city options
                 */
                var setMultiCityOptions = function() {
                    cache.get('#partnerAirlineLink').toggle(isRedeemMiles);
                    cache.get('#optionsSection').toggle(!isAirPassBooking);

                    toggleMultiCitySearchByList();
                    toggleMultiCityPassengerOptions();
                };

                /**
                 * Update multi city segment section
                 */
                var updateMultiCitySection = function() {
                    var totalMultiCitySegment = cache.get('.airport-segment').length;
                    if (isRedeemMiles) {
                        cache.get('#addFlightLinkSection').toggle(totalMultiCitySegment < AWARD_MAX_FLIGHT_SEGMENT);
                    } else {
                        cache.get('#addFlightLinkSection').toggle(totalMultiCitySegment < MAX_FLIGHT_SEGMENT);
                        disableTripLinkCheckbox(true);
                    }

                    var travelType = $j('#travelType').val();
                    if (isRedeemMiles || isAirPassBooking || travelType === 'business') {
                        cache.get('#oneWorldExplorer').hide();
                    } else {
                        cache.get('#oneWorldExplorer').show();
                    }

                    var deleteLinks = cache.get('button.delete-flight-link');
                    if (deleteLinks.length) {
                        deleteLinks.hide();
                        var lastLink = deleteLinks.get(deleteLinks.length - 1);
                        if (lastLink) {
                            lastLink.style.display = 'inline';
                        }
                    }

                    cache.get('div.flight-label').show();
                    cache.get('.multicity').show();

                    // select AA only for M/C flights 3/4
                    if (totalMultiCitySegment >= 3) {
                        $j('#airline').val('AA');
                    }
                };

                /**
                 * Show Round trip view
                 */
                var showRoundTripView = function() {
                    var tripLinkSelectedStatus = sessionStorage.getItem('triplinkUserSelectionMade');
                    var travelType = $j('#travelType').val();

                    cache.get('#recentSearchSection').show();
                    cache.get('div.flight-label').hide();
                    cache.get('.multicity').hide();
                    cache.get('#addFlightLinkSection').hide();
                    cache.get('#oneWorldExplorer').hide();
                    cache.get('#departDateSection').show();
                    cache.get('#returnDateSection').appendTo('#airportSection');
                    cache.get('#returnDateLabel').text(AAUI.getProperty('Return'));
                    cache.get('#returnDateSection').show();

                    isRedeemMiles || isAirPassBooking ? disableTripLinkCheckbox(true) : disableTripLinkCheckbox(false);

                    tripLinkSelectedStatus === 'true' || isAirPassBooking || isRedeemMiles || travelType === 'business'
                        ? cache.get('#hotelLink').hide()
                        : cache.get('#hotelLink').show();

                    if (tripLinkSelectedStatus === 'true' && corporateAccount && travelType === 'business') {
                        disableAirPassCheckbox(true);
                        if (businessCompanyNames !== '{}') {
                            $j('.corporateNameDiv').show();
                        }
                    }

                    if (isAirpassNextGen || corporateAccount) {
                        $j('.travelTypeDiv').show();
                    }

                    AAUI.dateRangePicker('#segments0\\.travelDate', { dateRange: 'on' });
                    AAUI.dateRangePicker('#segments1\\.travelDate', { dateRange: 'on' });
                    $j('button.ui-datepicker-trigger').append(
                        "<span class='hidden-accessible'>" + AAUI.getProperty('calendar.hiddenText') + '</span>'
                    );
                    // AAUI.datePickerA11Y();
                };

                /**
                 * Show One-Way view
                 */
                var showOneWayView = function() {
                    var tripLinkSelectedStatus = sessionStorage.getItem('triplinkUserSelectionMade');
                    var travelType = $j('#travelType').val();

                    cache.get('#recentSearchSection').show();
                    cache.get('div.flight-label').hide();
                    cache.get('.multicity').hide();
                    cache.get('#hotelLink').hide();
                    cache.get('#oneWorldExplorer').hide();
                    cache.get('#addFlightLinkSection').hide();
                    cache.get('#dateSection').hide();
                    cache.get('#returnDateSection').hide();
                    cache.get('#departDateSection').show();

                    isRedeemMiles || isAirPassBooking ? disableTripLinkCheckbox(true) : disableTripLinkCheckbox(false);

                    tripLinkSelectedStatus === 'true' || isAirPassBooking || isRedeemMiles
                        ? cache.get('#hotelLink').hide()
                        : cache.get('#hotelLink').show();

                    if (tripLinkSelectedStatus === 'true' && corporateAccount && travelType === 'business') {
                        disableAirPassCheckbox(true);
                        if (businessCompanyNames != '{}') {
                            $j('.corporateNameDiv').show();
                        }
                    }

                    if (isAirpassNextGen || corporateAccount) {
                        $j('.travelTypeDiv').show();
                    }

                    AAUI.dateRangePicker('#segments1\\.travelDate', { dateRange: 'off' });
                };

                /**
                 * Show Multi-city view
                 */
                var showMultiCityView = function() {
                    cache.get('#recentSearchSection').hide();
                    cache.get('#hotelLink').hide();
                    cache.get('#oneWorldExplorer').show();
                    cache.get('#dateSection').hide();

                    reloadMaxSegments(isRedeemMiles);
                    updateMultiCitySection();

                    cache.get('#departDateSection').appendTo('#airportSection');
                    cache.get('#returnDateSection').appendTo('#returnAirportSection');
                    cache.get('#returnDateSection').show();
                    cache.get('#returnDateLabel').text(AAUI.getProperty('Depart'));

                    AAUI.dateRangePicker('#segments0\\.travelDate', { dateRange: 'off' });
                    AAUI.dateRangePicker('#segments1\\.travelDate', { dateRange: 'off' });
                    $j('button.ui-datepicker-trigger').append(
                        "<span class='hidden-accessible'>" + AAUI.getProperty('calendar.hiddenText') + '</span>'
                    );
                };

                /**
                 * Render search page
                 */
                var render = function(tabChanged) {
                    updateAwardPageView();

                    switch (getCurrentTripType()) {
                        case tripType.RoundTrip:
                            showRoundTripView();
                            setTripOptions();
                            break;
                        case tripType.OneWay:
                            showOneWayView();
                            setTripOptions();
                            break;
                        case tripType.MultiCity:
                            showMultiCityView();
                            setMultiCityOptions();
                            break;
                    }

                    if (tabChanged) {
                        resetReturnFlightData();
                    }

                    AAUI.datePickerA11Y();

                    if (isRedeemMiles) {
                        cache.get('#hiddenRoundTrip').text(AAUI.getProperty('NavAwardRoundTrip'));
                        cache.get('#hiddenOneWay').text(AAUI.getProperty('NavAwardOneWay'));
                        cache.get('#hiddenMultiCity').text(AAUI.getProperty('NavAwardMulti'));
                    } else {
                        cache.get('#hiddenRoundTrip').text(AAUI.getProperty('NavRoundTrip'));
                        cache.get('#hiddenOneWay').text(AAUI.getProperty('NavOneWay'));
                        cache.get('#hiddenMultiCity').text(AAUI.getProperty('NavMulti'));
                    }
                };

                /**
                 * Reset return flight information
                 */
                var resetReturnFlightData = function() {
                    var segmentCount = cache.get('.airport-segment').length;
                    for (var i = 1; i < segmentCount; i++) {
                        cache.get('#segments' + i + '\\.origin').val('');
                        cache.get('#segments' + i + '\\.destination').val('');
                        cache.get('#segments' + i + '\\.travelDate').val('');
                    }
                };

                //
                //  Event Handlers Section
                //
                /**
                 * Add flight segment
                 * @param {event}
                 */
                var addSegment = function(event) {
                    event.preventDefault();
                    addNewSegment();
                    updateMultiCitySection();
                };

                /**
                 * Add flight segment
                 */
                var addNewSegment = function() {
                    var segmentCount = cache.get('.airport-segment').length;
                    var maxSegment = isRedeemMiles ? AWARD_MAX_FLIGHT_SEGMENT : MAX_FLIGHT_SEGMENT;

                    if (segmentCount < maxSegment) {
                        var segment = templates.airport({
                            index: segmentCount,
                            flightNo: segmentCount + 1,
                            prevSegmentIndex: segmentCount - 1,
                            flightNumberLabelText: AAUI.getProperty('flightLabel' + (segmentCount + 1)),
                            airportPlaceholderText: AAUI.getProperty('airportPlaceholderText'),
                            dateFormatPlaceholderText: AAUI.getProperty('dateFormatPlaceholderText')
                        });

                        cache.get('#addFlightLinkSection').before(segment);

                        // Bind datepicker to new date field
                        const mobileView = $device.mobile || window.innerWidth < 768;
                        let datePickerselector = mobileView
                            ? {
                                  dateRange: {
                                      start: '#segments' + (segmentCount - 1) + '\\.travelDate',
                                      end: '#segments' + segmentCount + '\\.travelDate'
                                  }
                              }
                            : '#segments' + segmentCount + '\\.travelDate';

                        initDatePicker(mobileView, datePickerselector);

                        AAUI.initAutoComplete(
                            '#segments' + segmentCount + '\\.origin, #segments' + segmentCount + '\\.destination'
                        );

                        // Cached airport segment section needs to be clear to correctly
                        // account for the added multi-city search
                        cache.remove('.airport-segment');
                        cache.remove('button.delete-flight-link');
                        cache.remove('div.flight-label');
                        cache.remove('.multicity');

                        cache.get('#flightSegmentTitle' + (segmentCount + 1)).focus();
                    }

                    AAUI.datePickerA11Y();
                };

                /**
                 * Reload max segments for award
                 * @param {boolean - isRedeemMiles}
                 */
                var reloadMaxSegments = function(isRedeemMiles) {
                    reloadSegments(isRedeemMiles ? AWARD_MAX_FLIGHT_SEGMENT : MAX_FLIGHT_SEGMENT);
                };

                /**
                 * Delete flight segment
                 * @param {event}
                 */
                var reloadSegments = function(visibleSegment) {
                    var objFlightLabel = cache.get('div.flight-label');
                    var objMultiCity = cache.get('.multicity');
                    var visibleSegmentCount = objMultiCity.length;
                    var segmentCount = visibleSegment - 1; // because it's zero based

                    if (visibleSegmentCount > segmentCount) {
                        for (var i = visibleSegmentCount; i > segmentCount; i--) {
                            objFlightLabel[i].parentNode.removeChild(objFlightLabel[i]);
                            objMultiCity[i - 1].parentNode.removeChild(objMultiCity[i - 1]);
                        }

                        // clear cached DOM elements
                        cache.remove('.airport-segment');
                        cache.remove('button.delete-flight-link');
                        cache.remove('div.flight-label');
                        cache.remove('.multicity');

                        render();
                    }
                };

                /**
                 * Delete flight segment
                 * @param {event}
                 */
                var deleteSegment = function(event) {
                    var $flightSegment = $j(event.target.parentNode.parentNode);

                    $flightSegment.next().remove();
                    $flightSegment.remove();

                    // clear cached DOM elements
                    cache.remove('.airport-segment');
                    cache.remove('button.delete-flight-link');
                    cache.remove('div.flight-label');
                    cache.remove('.multicity');

                    render();

                    var segmentCount = cache.get('.airport-segment').length;
                    cache.remove('#flightSegmentTitle' + (segmentCount + 1));
                    cache.get('#flightSegmentTitle' + segmentCount).focus();
                };

                /**
                 * Process passenger drop down change
                 */
                var processPassengers = function() {
                    showPassengers(this.value);
                };

                /**
                 * Update page view on award selection
                 */
                var updateAwardPageView = function() {
                    cache.get('#partnerAirlineLink').toggle(isRedeemMiles);
                    cache.get('#hotelLink').toggle(!isRedeemMiles);

                    if (isRedeemMiles) {
                        disableTripLinkCheckbox(true);
                        $j(airPassCheckbox).prop('disabled', true);
                        $j('#airlineSection label[for="airline"]').hide();
                        $j('#airlineSection label[for="awardAirline"]').show();
                        $j('div.depart div.revenue-nearby-airport').hide();
                        $j('div.depart div.award-nearby-airport').show();
                        $j('#revenueSearchOptionLabel').hide();
                    } else {
                        disableTripLinkCheckbox(false);
                        $j(airPassCheckbox).prop('disabled', false);
                        $j('#airlineSection label[for="awardAirline"]').hide();
                        $j('#airlineSection label[for="airline"]').show();
                        $j('#awardSearchOptionLabel').hide();
                        $j('#revenueSearchOptionLabel').hide();
                    }
                };

                /**
                 * Update view for Award booking.
                 */
                var setAwardBooking = function() {
                    isRedeemMiles = cache.get(redeemMilesCheckbox).prop('checked');
                    render();
                };

                var handleAirportChange = function() {
                    render();
                };

                /**
                 * Event handler of recent search drop down
                 */
                var handleRecentSearch = function() {
                    var selectedSearch = cache.get('#recentSearchDropDown').val();

                    if (selectedSearch == 'waterMark') {
                        return;
                    }

                    if (selectedSearch == clearRecentSearchesKey) {
                        deleteRecentSearchesFromLS();
                        cache.get('#recentSearchSection').remove();
                    } else {
                        var recentSearchId = cache.get('#recentSearchDropDown').val();
                        var tripTypeValue = recentSearches.get(recentSearchId, 'tripType');

                        recentSearches.set(recentSearchId);

                        var departDate = new Date(cache.get('#segments0\\.travelDate').val());
                        var arrivalDate = new Date(cache.get('#segments1\\.travelDate').val());

                        var activeTab = $j('#flight-tabs').tabs('option', 'active');
                        var selectedTripType = tripTypeValueToInt(tripTypeValue);
                        if (activeTab === selectedTripType) {
                            render();
                        } else {
                            $j('#flight-tabs').tabs('option', 'active', selectedTripType);
                        }

                        // make sure the travel date fields exists before updating them.
                        cache.get('#segments0\\.travelDate').val($j.datepicker.formatDate(dateFormat, departDate));
                        cache
                            .get('#segments1\\.travelDate')
                            .val($j.datepicker.formatDate(dateFormat, isNaN(arrivalDate) ? '' : arrivalDate));

                        exposeAnalyticsRecentSearchEvent();
                    }
                };

                var replaceAll = function(str, find, replace) {
                    return str.replace(new RegExp(find, 'g'), replace);
                };

                var exposeAnalyticsRecentSearchEvent = function() {
                    var dataArray = [];
                    dataArray[0] = new KeyValueObject('recent_search', 'Yes');
                    waTealiumUtils.reportEvent(dataArray, 'click');
                };

                /**
                 * Set AirPass value
                 */
                var setAirPass = function() {
                    isAirPassBooking = this.checked;

                    if (isAirPassBooking) {
                        airPassBookingView();
                    } else {
                        $j(redeemMilesCheckbox).prop('disabled', false);
                        disableTripLinkCheckbox(false);
                        cache.get('#optionsSection').show();
                        cache.get('#hotelLink').show();
                        cache.get('#oneWorldExplorer').show();
                        cache.get('#tabMultiCity').show();

                        toggleAirpassPassengerList(false, false);
                    }

                    if (getCurrentTripType() === tripType.MultiCity) {
                        disableTripLinkCheckbox(true);
                    }
                };

                /**
                 * AirPass Booking
                 */
                var airPassBookingView = function() {
                    var isAirPass = cache.get(airPassCheckbox).prop('checked');

                    if (isAirPass) {
                        cache.get(redeemMilesCheckbox).prop('disabled', true);
                        disableTripLinkCheckbox(true);
                        toggleAirpassPassengerList(isAirpassCompanionAllowed, true);

                        cache.get('#optionsSection').hide();
                        cache.get('#hotelLink').hide();
                        cache.get('#oneWorldExplorer').hide();

                        if (isAirpassNextGen) {
                            cache.get('#tabMultiCity').hide();

                            if (tripType.MultiCity === getCurrentTripType()) {
                                cache
                                    .get('#flight-tabs')
                                    .tabs('option', 'active', tripTypeValueToInt(tripType.RoundTrip));
                            }
                        }
                    }
                };

                var initTripLink = function() {
                    // We no longer default to corporate checked when the user logs in (only back button remembers)
                    var tripLinkSelectedStatus = sessionStorage.getItem('triplinkUserSelectionMade');

                    if (tripLinkSelectedStatus === null || tripLinkSelectedStatus === 'false') {
                        cache.get(tripLinkCheckbox).prop('checked', false);
                    } else if (tripLinkSelectedStatus === 'true' && tripLinkAccount) {
                        cache.get(tripLinkCheckbox).prop('checked', true);
                        $j(redeemMilesCheckbox).prop('disabled', true);
                        $j(redeemMilesCheckbox).prop('checked', false);
                        $j(airPassCheckbox).prop('disabled', true);
                        $j(airPassCheckbox).prop('checked', false);
                        disablePassengersDropdown(true);
                    }
                };

                /**
                 * Disable TripLink Checkbox
                 */
                var disableTripLinkCheckbox = function(disableTripLink) {
                    cache.get(tripLinkCheckbox).prop('disabled', disableTripLink);
                };

                /**
                 * Disable AirPass Checkbox
                 */
                var disableAirPassCheckbox = function(disableAirPass) {
                    cache.get(airPassCheckbox).prop('disabled', disableAirPass);
                    cache.get(airPassCheckbox).prop('checked', false);
                };

                /**
                 * Hide passenger drop-down
                 * @param {boolean} disableDropdown
                 */
                var disablePassengersDropdown = function(disableDropdown) {
                    if (disableDropdown) {
                        showPassengers(1);
                        $j('#passengerCount option[value="1"]').prop('selected', true);
                    }
                    cache.get('#passengerCount').prop('disabled', disableDropdown);
                };

                AAUI.onChange('#travelType', function() {
                    var selectedValue = $j(this).val();
                    var selectedTripType = cache.get('#tripType').val();
                    var selectedTripTypeTabValue = tripTypeValueToInt(selectedTripType);
                    $j('#thresholdMessage').hide();

                    if (selectedValue === 'business') {
                        $j(redeemMilesCheckbox).prop({ disabled: true, checked: false });
                        setAwardBooking();
                        hideLinks();
                        disablePassengersDropdown(true);
                        disableTripLinkCheckbox(false);
                        disableAirPassCheckbox(true);
                        cache.get(tripLinkCheckbox).prop('checked', true);

                        if (businessCompanyNames != '{}') {
                            $j('.corporateNameDiv').show();

                            if (businessCompanyNamesCount == '1') {
                                onlyShowOneCompanyName();
                            } else if (businessCompanyNamesCount != '-1') {
                                // only set to -1 if there is more than 1 company name in businesslist
                                $j('#corporateName').val('-1');
                                $j('#corporateNameTextBox').hide();
                            }
                        }

                        // If we were in a multicity state (before clicking 'Business') reset active tab back to Round Trip
                        if (selectedTripTypeTabValue === 2) {
                            disableAirPassCheckbox(true);
                        }
                        // If we were in a one way state, we have to append the depart date so it rolls below
                        // because company name takes its spot if you chose "Business"
                        if (selectedTripTypeTabValue === 1) {
                            $j('#departDateSection').appendTo('#dateSection');
                        }
                        // sessionStorage.setItem('triplinkUserSelectionMade', 'false');
                    } else if (selectedValue === 'airpass') {
                        $j(redeemMilesCheckbox).prop({ disabled: true, checked: false });
                        cache.get(tripLinkCheckbox).prop('checked', false);
                        disableTripLinkCheckbox(true);
                        $j('.corporateNameDiv').hide();
                        $j('#corporateName').val('-1');
                        $j('.businessTravelerDiv').hide();

                        $j(airPassCheckbox).prop({ disabled: false, checked: true });
                        toggleAirpassPassengerList(isAirpassCompanionAllowed, true);
                        disablePassengersDropdown(false);
                        hideLinks();
                        cache.get('#optionsSection').hide();
                        if (tripType.MultiCity === getCurrentTripType()) {
                            cache.get('#flight-tabs').tabs('option', 'active', tripTypeValueToInt(tripType.RoundTrip));
                        }
                        sessionStorage.setItem('triplinkUserSelectionMade', 'false');
                    } else {
                        $j('.corporateNameDiv').hide();
                        $j('.businessMilesText').hide();
                        // only set to -1 if there is more than 1 company name in businesslist
                        if (businessCompanyNamesCount != '1') {
                            $j('#corporateName').val('-1');
                        }
                        $j('.businessTravelerDiv').hide();
                        cache.get(redeemMilesCheckbox).prop('disabled', false);
                        $j(airPassCheckbox).prop({ disabled: false, checked: false });
                        cache.get('#tabMultiCity').show();
                        cache.get('#hotelLink').show();
                        cache.get('#oneWorldExplorer').show();
                        cache.get('#optionsSection').show();
                        disablePassengersDropdown(false);
                        updatePassengerList();
                        toggleAirpassPassengerList(false, false);
                        cache.get(tripLinkCheckbox).prop('checked', false);
                        sessionStorage.setItem('triplinkUserSelectionMade', 'false');
                    }
                    _setToSession(isTripLinkBooking);
                });

                AAUI.onChange('#corporateName', function() {
                    var selectedValue = $j(this).val();

                    if (selectedValue == '-1' || selectedValue == '' || tripLinkOnlyAccount) {
                        $j('.businessTravelerDiv').hide();
                        $j('.businessMilesText').hide();
                        $j('#thresholdMessage').hide();
                        $j('#awardBooking').prop({ disabled: true, checked: false });
                    } else {
                        businessTravelerAjaxCall(selectedValue, false);
                    }
                });

                var hideLinks = function() {
                    cache.get('#hotelLink').hide();
                    cache.get('#oneWorldExplorer').hide();

                    var travelType = $j('#travelType').val();
                    if (travelType === 'airpass') {
                        cache.get('#tabMultiCity').hide();
                    } else {
                        cache.get('#tabMultiCity').show();
                    }
                };

                var _setToSession = function(isTripLinkBooking) {
                    // Business rule:
                    // If the user unchecks the triplink checkbox,
                    // do not default it to checked again during the session
                    AAUI.ajaxRequest({
                        url: '/home/ajax/triplinkSelection',
                        type: 'GET',
                        data: { tripLink: isTripLinkBooking },
                        dataType: 'JSON',
                        timeout: 5000,
                        showBusy: false,
                        onSuccess: (jsonResponse, textStatus) => {},
                        onError: () => {},
                        onComplete: () => {}
                    });
                };

                /**
                 * Form submit event handler
                 */
                var submitHandler = function() {
                    $j('body')
                        .aaBusy({ message: AAUI.getProperty('loadingTxt') })
                        .start();

                    return true;
                };

                ///////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                   //
                // Initialization Section                                                                            //
                //                                                                                                   //
                ///////////////////////////////////////////////////////////////////////////////////////////////////////

                /**
                 * Initialize trip type small nav tabs
                 * Save trip type selected on tab change
                 */
                var initFlightSearchTab = function() {
                    updateFormViewCSS(selectedTripType);
                    $j('#flight-tabs').tabs({
                        active: tripTypeValueToInt(selectedTripType),
                        activate: function(event, ui) {
                            setTripType(ui.newTab.index());
                            render(true);
                        }
                    });
                };

                /**
                 * Initialize Trip type value to navigation tab mapping.
                 */
                var initTripTypeMappings = function() {
                    tripTypeNavTabMappings = [tripType.RoundTrip, tripType.OneWay, tripType.MultiCity];
                };

                /**
                 * Save segment values
                 * @param {string} name of element
                 */
                var initRetainedSegments = function(name) {
                    if (name.startsWith('segments[')) {
                        var elem = cache.get("[name='" + name + "']");

                        if (!elem.length) {
                            addNewSegment();
                        }

                        cache.remove("[name='" + name + "']");
                    }
                };

                /**
                 * Assign user hometown to origin airport
                 */
                var setDefaultOrigin = function() {
                    if (homeTownAirport.length && cache.get('#segments0\\.destination').val().length <= 0) {
                        cache.get('#segments0\\.origin').val(homeTownAirport);
                    }
                };

                /**
                 * Initialize hometown airport
                 * @param {string} name of form element
                 * @param {string} value value of form element
                 */
                var initHometownAirport = function(name, value) {
                    if (name != firstDestination) {
                        return false;
                    }

                    var noDestinationFilled = value.length <= 0;
                    var homeTownAirportIsAvailable = homeTownAirport.length > 0;

                    if (noDestinationFilled && homeTownAirportIsAvailable) {
                        originIsHomeTown = true;
                    }

                    return originIsHomeTown;
                };

                /***
                 * Set origin home town
                 */
                var setOriginToHometown = function() {
                    if (originIsHomeTown) {
                        cache.get('#segments0\\.origin').val(homeTownAirport);
                        cache.get(redeemMilesCheckbox).prop('checked', false);
                        cache.get('#segments0\\.useNearbyOriginAirports1').prop('checked', false);
                        cache.get('#segments0\\.useNearbyDestinationAirports1').prop('checked', false);
                        cache.get('#segments0\\.travelDate').datepicker('setDate', new Date());

                        if (getCurrentTripType() == tripType.RoundTrip) {
                            cache.get('#segments1\\.travelDate').datepicker('setDate', '+7d');
                        } else if (getCurrentTripType() == tripType.MultiCity) {
                            cache.get('#segments1\\.travelDate').val('');
                        }

                        originIsHomeTown = false;
                    }
                };

                /**
                 * Restore search values saved in storage
                 */
                var restoreSavedSearch = function() {
                    // - deserialize form data
                    // - assign value to form element
                    if (sessionStorage && isFromLogin()) {
                        var flightForm = sessionStorage.getItem(FLIGHT_SEARCH_FORM_CACHE_KEY);

                        if (flightForm) {
                            // clear cached DOM elements
                            cache.remove('.airport-segment');
                            cache.remove('button.delete-flight-link');
                            cache.remove('div.flight-label');
                            cache.remove('.multicity');

                            var params = flightForm.split('&'),
                                max = params.length,
                                i = 0,
                                elem,
                                nameValuePair = [],
                                name,
                                value,
                                searchOption,
                                cabin,
                                airline;

                            while (i < max) {
                                nameValuePair = params[i].split('=');
                                if (nameValuePair.length < 1) {
                                    continue;
                                }

                                name = unescape(nameValuePair[0]);
                                value = unescape(nameValuePair[1]);

                                initRetainedSegments(name);
                                elem = cache.get("[name='" + name + "']");

                                if (elem.length) {
                                    if (elem.prop('type') === 'checkbox') {
                                        elem.prop('checked', value);
                                    } else if (elem.prop('type') === 'radio') {
                                        var index = elem.length;

                                        if (name == 'awardBooking') {
                                            isRedeemMiles = value == 'true';
                                        }

                                        // put a check on the selected radio button
                                        // find the match by using value
                                        while (index--) {
                                            if (elem[index].value === value) {
                                                elem[index].checked = true;

                                                break;
                                            }
                                        }
                                    } else {
                                        // selects and textbox
                                        switch (name) {
                                            case 'searchOption':
                                                searchOption = value;
                                                break;
                                            case 'cabin':
                                                cabin = value;
                                                break;
                                            case 'airline':
                                                airline = value;
                                                break;
                                            case 'tripType':
                                                selectedTripType = value;
                                                break;
                                            default:
                                                // default case
                                                break;
                                        }

                                        elem.val(value);
                                    }
                                }
                                i++;
                            }
                            showPassengers(cache.get('#passengerCount').val());

                            // View and drop-downs have correct options
                            // Set the saved selected option
                            cache.get('#searchOption').val(searchOption);
                            cache.get('#cabin').val(cabin);
                            cache.get('#airline').val(airline);

                            toggleCheckbox(
                                cache.get(airPassCheckbox).prop('checked'),
                                '#refundable1',
                                '#refundableSection'
                            );
                            toggleCheckbox(cache.get('#refundable1').prop('checked'), airPassCheckbox, airPassBooking);

                            toggleCheckbox(
                                cache.get(tripLinkCheckbox).prop('checked'),
                                '#refundable1',
                                '#refundableSection'
                            );
                            toggleCheckbox(
                                cache.get('#refundable1').prop('checked'),
                                tripLinkCheckbox,
                                tripLinkBooking
                            );
                        }

                        sessionStorage.removeItem(FLIGHT_SEARCH_FORM_CACHE_KEY);
                    }
                };

                /**
                 * Check if user is from the home page
                 */
                var isFromTheHomePage = function() {
                    var referrer = document.referrer;

                    return referrer && referrer.indexOf('/homePage.do') > -1;
                };

                /**
                 * Check if user is from login
                 */
                var isFromLogin = function() {
                    var referrer = document.referrer;

                    return referrer && referrer.indexOf('/loyalty/login') > -1;
                };

                /**
                 * Save form values to sessionStorage before redirect to login/logoff page
                 */
                var initAccountLogin = function() {
                    $j('#loginLogoutLink, #logInAdvantageLink').click(function(e) {
                        e.preventDefault();

                        // Save flight search to browser's sessionStorage
                        try {
                            if (sessionStorage) {
                                sessionStorage.setItem(TRIP_TYPE_CACHE_KEY, cache.get('#tripType').val());
                                sessionStorage.setItem(AWARD_CACHE_KEY, cache.get(redeemMilesCheckbox).prop('checked'));
                                sessionStorage.setItem(FLIGHT_SEARCH_FORM_CACHE_KEY, $flightSearchForm.serialize());
                            }
                        } catch (error) {
                            // Safari still doesn't allow store setting in private mode
                        }

                        // Logoff needs to call delete vpnr and redirect to logoff page.
                        if (isSecure) {
                            deleteVirtualPNR();
                            window.location.href = this.href;

                            return;
                        }

                        // Call login script. It will handle the cleanup and redirect to login page.
                        deleteVPNRModal();
                    });
                };

                /**
                 * Datepicker beforeShow event handler
                 * @param {object} input field
                 * @param {object} inst datepicker instance
                 */
                var onBeforeShow = function(input, inst) {
                    var minDate = null,
                        $input = $j(input),
                        prevDepartDateId = $input.data('prev-departure-date');

                    if (prevDepartDateId) {
                        var $prevDepartDateField = cache.get(getId(prevDepartDateId));
                        var date = $prevDepartDateField.datepicker('getDate');

                        if (date instanceof Date) {
                            minDate = date;
                        }
                    }

                    $input.datepicker('option', 'minDate', minDate || 0);
                    AAUI.datePickerA11Y();
                    this.fixFocusIE = false;
                };

                var businessTravelerAjaxCall = function(selectedValue, rememberBT) {
                    if (!selectedValue || selectedValue.length < 1) {
                        return;
                    }

                    AAUI.ajaxRequest({
                        url: '/loyalty/api/smb/members/' + selectedValue,
                        type: 'GET',
                        dataType: 'json',
                        onSuccess: function(parseResponse) {
                            var members = parseResponse.associatedMembers;
                            var role = parseResponse.role;

                            if (role === 'Account Travel Manager') {
                                var formattedBalance = 0;
                                var milesBalance = parseInt(parseResponse.milesBalance);
                                if (!isNaN(milesBalance)) {
                                    formattedBalance = milesBalance.toLocaleString();
                                }
                                $j('.businessMilesText').html(formattedBalance + ' ' + milesBalanceTxt);
                                $j('.businessMilesText').show();

                                var threshold = parseResponse.thresholdFlag;
                                if (!threshold) {
                                    $j('#awardBooking').prop({ disabled: true, checked: false });
                                    $j('#thresholdMessage').show();
                                } else {
                                    var isAwardChecked =  $j('#awardBooking').is(':checked');
                                    $j('#awardBooking').prop({ disabled: false, checked: isAwardChecked });
                                    $j('#thresholdMessage').hide();
                                }
                            } else {
                                $j('.businessMilesText').hide();
                                $j('#awardBooking').prop({ disabled: true, checked: false });
                                $j('#thresholdMessage').hide();
                            }

                            if (Object.keys(members).length > 1) {
                                $j('.businessTravelerDiv').show();
                                $j('#businessTraveler').empty();

                                $j.each(members, function(key, value) {
                                    if (key === businessTraveler && rememberBT) {
                                        $j('#businessTraveler').append(
                                            $j('<option selected></option>')
                                                .val(key)
                                                .html(value)
                                        );
                                    } else {
                                        $j('#businessTraveler').append(
                                            $j('<option></option>')
                                                .val(key)
                                                .html(value)
                                        );
                                    }
                                });
                            } else {
                                $j('.businessTravelerDiv').hide();
                                $j.each(members, function(key, value) {
                                    $j('#businessTraveler').append(
                                        $j('<option selected></option>')
                                            .val(key)
                                            .html(value)
                                    );
                                });
                            }
                        },
                        onError: function() {
                            /* don't propagate error to page */
                        }
                    });
                };

                var onlyShowOneCompanyName = function() {
                    var companyNameParse = corporateName.split('|');
                    if (companyNameParse) {
                        var htmlCompanyName = new DOMParser().parseFromString(companyNameParse[1], 'text/html');
                        if (htmlCompanyName) {
                            htmlCompanyName = htmlCompanyName.documentElement.textContent;
                            $j('#corporateNameTextBox').val(htmlCompanyName);
                            $j('#corporateNameTextBox').show();
                            $j('#corporateName').hide();
                            $j('#corporateName').val(companyNameParse[0]);
                        }
                    }

                    if (!tripLinkOnlyAccount) {
                        // parse out the company id and trigger ajax call
                        var companyId = corporateName.split('|')[0];
                        businessTravelerAjaxCall(companyId, true);
                    }
                };

                /**
                 * WARNING: ONLY CALL ON _PAGE LOAD_!!!
                 *
                 * Initialize normal/tablet view: setup event handler, default values, and modules
                 * @return {function} normal/tablet render function
                 */
                var initView = function() {
                    var init = AAUI.getProperty('init') === 'true';

                    disablePassengersDropdown(false);

                    if (isFromLogin()) {
                        selectedTripType = sessionStorage.getItem(TRIP_TYPE_CACHE_KEY);
                        isRedeemMiles = sessionStorage.getItem(AWARD_CACHE_KEY) == 'true';

                        setTripType(tripTypeValueToInt(selectedTripType));
                        cache.get(redeemMilesCheckbox).prop('checked', isRedeemMiles);
                    } else {
                        selectedTripType = cache.get('#tripType').val();
                        isRedeemMiles = cache.get(redeemMilesCheckbox).prop('checked');
                    }

                    isFromHomePage = isFromTheHomePage();
                    isAirPassBooking = cache.get(airPassCheckbox).prop('checked');

                    var travelType = $j('#travelType').val();
                    if (travelType === 'airpass' && isAirPassBooking) {
                        $j('#awardBooking').prop({ disabled: true, checked: false });
                        hideLinks();
                    }

                    if (travelType === 'business' && corporateAccount) {
                        sessionStorage.setItem('triplinkUserSelectionMade', 'true');
                        $j('#tripLink').prop({ disabled: false, checked: true });
                        hideLinks();
                        disablePassengersDropdown(true);

                        if (businessCompanyNames !== '{}') {
                            $j('.corporateNameDiv').show();
                            $j('#corporateNameTextBox').hide();

                            if (businessCompanyNamesCount == '1') {
                                onlyShowOneCompanyName();
                            }
                            if (corporateName !== '-1' && !tripLinkOnlyAccount) {
                                businessTravelerAjaxCall(corporateName, true);
                            }
                        }
                    }

                    airPassBookingView();
                    initFlightSearchTab();
                    initAccountLogin();
                    initDatePicker($device.mobile || window.innerWidth < 768);

                    AAUI.initAirportLookup('.aaAirportLookup');
                    AAUI.initNearestAirportLookup('.current-location-btn');

                    cache.get('#addFlightLink').on('click', addSegment);
                    cache.get('#airportDateSection').on('click', 'button.delete-flight-link', deleteSegment);
                    cache.get('#passengerCount').on('change', processPassengers);
                    cache.get(redeemMilesCheckbox).on('change', setAwardBooking);
                    cache.get('#recentSearchDropDown').on('change', handleRecentSearch);
                    cache.get('#segments0\\.origin').on('blur', handleAirportChange);
                    cache.get('#segments0\\.destination').on('blur', handleAirportChange);
                    cache.get('#segments1\\.origin').on('blur', handleAirportChange);
                    cache.get('#segments1\\.destination').on('blur', handleAirportChange);

                    if (isSecure) {
                        cache.get(airPassCheckbox).on('click', setAirPass);
                    }

                    recentSearches.init();
                    templates.airport = Handlebars.compile($j('#airportTemplate').html());

                    AAUI.initAutoComplete('.aaAutoComplete', false, { position: { collision: 'flip' } });
                    $flightSearchForm.on('submit', submitHandler);

                    $j(window).on('pageshow', function(event) {
                        if (event.originalEvent.persisted) {
                            window.location.reload();
                        }
                    });

                    $j(window).on(
                        'resize',
                        debounce(function() {
                            initDatePicker($device.mobile || window.innerWidth < 768);
                        })
                    );
                };

                /**
                 * Initialize search page
                 */
                var init = function() {
                    cache.clear();
                    initTripTypeMappings();
                    initView();
                    render(false);

                    restoreSavedSearch();
                    setDefaultOrigin();
                    setOriginToHometown();
                    initTripLink();
                };

                return {
                    init: init
                };
            })(jQuery.noConflict(), $device, aaCache);

            search.init();
        });
    }
);
